import React from 'react';
import { ReactComponent as Patients } from 'assets/img/icons/patients.svg';
import { ReactComponent as Users } from 'assets/img/icons/user.svg';
import { ReactComponent as Notifications } from 'assets/img/icons/notifications.svg';
import { ReactComponent as Settings } from 'assets/img/icons/settings.svg';
import { ReactComponent as Trash } from 'assets/img/icons/trash.svg';
import { ReactComponent as BackArrow } from 'assets/img/icons/backArrow.svg';
import { ReactComponent as BackArrowSmall } from 'assets/img/icons/backArrowSmall.svg';
import { ReactComponent as NextArrow } from 'assets/img/icons/nextArrow.svg';
import { ReactComponent as NextArrowOrange } from 'assets/img/icons/nextArrowOrange.svg';
import { ReactComponent as Cloud } from 'assets/img/icons/cloud.svg';
import { ReactComponent as Close } from 'assets/img/icons/close.svg';
import { ReactComponent as Question } from 'assets/img/icons/question.svg';
import { ReactComponent as ArrowBottom } from 'assets/img/icons/arrowBottom.svg';
import { ReactComponent as ArrowBottomSmall } from 'assets/img/icons/arrowBottomSmall.svg';
import { ReactComponent as ArrowBottomBlue } from 'assets/img/icons/arrowBottomBlue.svg';
import { ReactComponent as ClinicalHistory } from 'assets/img/icons/clinicalHistory.svg';
import { ReactComponent as ArrowSmall } from 'assets/img/icons/arrowSmall.svg';
import { ReactComponent as Hospital } from 'assets/img/icons/hospital.svg';
import { ReactComponent as Search } from 'assets/img/icons/search.svg';

const svgIcons: Record<
	string,
	React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
	Patients,
	Users,
	Cloud,
	Close,
	Question,
	ArrowBottom,
	ArrowBottomSmall,
	ArrowBottomBlue,
	Notifications,
	Settings,
	Trash,
	BackArrow,
	BackArrowSmall,
	NextArrow,
	NextArrowOrange,
	ClinicalHistory,
	ArrowSmall,
	Hospital,
	Search,
};

export default svgIcons;
